import Api from 'api';
import { FormCaptchaChallenge, FormCaptchaType } from '@axl/accel-framework/models';

export default class CaptchaApi {
    constructor(private api: Api) {
    }

    public async create(type: FormCaptchaType) {
        return await this.api.post<FormCaptchaChallenge>('/c', { type });
    }

    public async solve(captchaId: string, positionX: number, solveMs: number) {
        return await this.api.post<{ token: string }>(`/c/${captchaId}/solution`, { positionX, solveMs });
    }
}
